import { Component, Input, EventEmitter, Output } from '@angular/core';
import { AuthService } from '../../../services';
import { PublishedMatch } from '../../../models';

@Component({
  selector: 'clone-match-button',
  templateUrl: './clone-match-button.component.html'
})
export class CloneMatchButtonComponent {
  
  @Input() match: PublishedMatch;
  @Output() readonly clone = new EventEmitter<PublishedMatch>();

  constructor(private authService: AuthService) {}

  onClone(match: PublishedMatch) {
    this.clone.emit(match);
  }
}
